import axios from "axios"
import AccessToken from "./AccessToken"
import { ShowErrorMsg } from "../../utils/ShowErrorMsg";
import Cookies from 'js-cookie';

const FetchLogout = async () => {
   const accessToken = AccessToken();

   try {
      await axios.post(`${process.env.REACT_APP_API_URL}/logout`, {}, {
         headers: {
            Authorization: `Bearer ${accessToken}`
         },
         withCredentials: true,
      })
      
      // access_token 쿠키 삭제
      Cookies.remove('access_token', { 
         path: '/',
         domain: window.location.hostname
      });

      alert('로그아웃 되었습니다.')
      
      // 캐시 무효화를 위한 리다이렉트
      window.location.replace('/');
   } catch (error) {
      console.error(error)
      ShowErrorMsg(error)
   }
}

export default FetchLogout